import { render, staticRenderFns } from "./file-item.vue?vue&type=template&id=bc549c4a&scoped=true"
import script from "./file-item.vue?vue&type=script&lang=ts"
export * from "./file-item.vue?vue&type=script&lang=ts"
import style0 from "./file-item.vue?vue&type=style&index=0&id=bc549c4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc549c4a",
  null
  
)

export default component.exports